module.exports = __webpack_public_path__ + "img/20200907_094750.60b079bd.jpg";